import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import barba from '@barba/core';
import Swiper from 'swiper';
import smoothscroll from 'smoothscroll-polyfill';
import List from 'list.js';

import 'swiper/swiper-bundle.css';

Alpine.plugin(persist);

Alpine.data('project', () => ({
  swiper: null,
  openGallery(i, title) {
    const that = this;
    this.galleryOpen = true;
    this.$dispatch('gallery-open', title);
    setTimeout(function () {
      document.querySelector('.swiper-container').classList.remove('hidden');
      that.swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        speed: 200,
        initialSlide: i,
      });
    }, 25);
  },
  closeGallery() {
    this.galleryOpen = false;
    document.querySelector('.swiper-container').classList.add('hidden');
    this.swiper.destroy();
  },
  prevSlide() {
    this.swiper.slidePrev();
  },
  nextSlide() {
    this.swiper.slideNext();
  },
}));

Alpine.store('gridOverlay', {
  on: Alpine.$persist(0),
});

Alpine.start();

smoothscroll.polyfill();

barba.init({
  views: [
    {
      namespace: 'home',
      afterEnter() {
        new List('list', {
          valueNames: ['name', 'location', 'date'],
        });
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        jQuery(jQuery('#homeGrid').children()[2]).find('img').toggleClass('opacity-0');
        setTimeout(function () {
          if (mediaQuery.matches) {
            jQuery(jQuery('#homeGrid').children()[2]).find('img').toggleClass('opacity-0');
          }
          jQuery(jQuery('#homeGrid').children()[1]).find('img').toggleClass('opacity-0');
        }, 500);
        setTimeout(function () {
          if (mediaQuery.matches) {
            jQuery(jQuery('#homeGrid').children()[1]).find('img').toggleClass('opacity-0');
          }
          jQuery(jQuery('#homeGrid').children()[0]).find('img').toggleClass('opacity-0');
        }, 1000);
        setTimeout(function () {
          if (mediaQuery.matches) {
            jQuery(jQuery('#homeGrid').children()[0]).find('img').toggleClass('opacity-0');
          }
          jQuery(jQuery('#homeGrid').children()[3]).find('img').toggleClass('opacity-0');
        }, 1500);
        setTimeout(function () {
          if (mediaQuery.matches) {
            jQuery(jQuery('#homeGrid').children()[3]).find('img').toggleClass('opacity-0');
          }
          jQuery('#homeGrid').children().toggleClass('pointer-events-none');
        }, 2000);
      },
    },
  ],
});

barba.hooks.afterLeave((data) => {
  var nextHtml = data.next.html;
  var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, 'jQuery1notbodyjQuery2>', nextHtml);
  var bodyClasses = jQuery(response).filter('notbody').attr('class');
  jQuery('body').attr('class', bodyClasses);
});

barba.hooks.enter((data) => {
  window.scrollTo(0, 0);
});

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
